import Api from 'api'

const config = {
  baseURL: '/api/app/v2/network-accounts',
}
const api = new Api(config)

api.getNetworkAccounts = ({ ...rest }) => api.get(``, { ...rest })

api.addNetworkAccount = ({ ...rest }) => api.post('', { ...rest })

api.getNetworkAccountById = ({ accountId, ...rest }) => api.get(`/${accountId}`, { ...rest })

api.archiveNetworkAccountsByIDs = ({ ...rest }) => api.post(`/archive`, { ...rest })

api.unarchiveNetworkAccountsByIDs = ({ ...rest }) => api.post(`/unarchive`, { ...rest })

api.deleteAccount = ({ ...rest }) => api.post(`/delete`, { ...rest })

api.updateName = ({ accountId, ...rest }) => api.put(`/${accountId}/name`, { ...rest })

api.getNetworkAccountExtraData = ({ networkId, accountId, ...rest }) => {
  const tempApi = new Api({
    baseURL: '/api/app/v2/networks',
  })

  return tempApi.get(`/${networkId}/accounts/${accountId}/extra-data`, {
    ...rest,
  })
}

export default api
